module.exports = __webpack_public_path__ + "img/140.b2a7b8a.jpg";